import React, { useEffect, useState } from "react";
import MetaDataService from "../../services/MetaDataService";
import { JhText } from "designPackages/textPackage";
import { JhButton } from "designPackages/buttonPackage";
import Image from "next/image";

interface SalesContactProps {
  onContactSalesClick: () => void;
}

interface SalesInfo {
  title?: string;
  subTitle?: string;
}

const SalesContact: React.FC<SalesContactProps> = ({ onContactSalesClick }) => {
  const [salesInfo, setSalesInfo] = useState<SalesInfo>({});

  useEffect(() => {
    const getSalesInfo = async () => {
      const data = await MetaDataService.getCreditInfo();
      setSalesInfo(data.data);
    };
    getSalesInfo();
  }, []);

  const { title, subTitle } = salesInfo;

  return (
    <>
      <div className="flex flex-col md:flex-row md:items-center md:justify-between items-start  w-full bg-background gap-3 p-3 md:py-8 md:px-5">
        <div className="flex w-full flex-col md:flex-row md:items-center gap-3 md:gap-2.5">
          <div className="flex-shrink-0">
            <Image
              src="/hire/sales-contact-icon.png"
              alt="call"
              width={47}
              height={45}
              className="w-auto h-auto"
            />
          </div>
          <div className="flex flex-col md:flex-row md:items-center gap-1.5 md:gap-2.5">
            <JhText variant="emphasis2" color="foreground">
              {title}
            </JhText>
            {subTitle && (
              <JhText variant="body2" color="muted-foreground">
                {subTitle}
              </JhText>
            )}
          </div>
        </div>
        <JhButton
          variant="outline"
          size="default"
          onClick={onContactSalesClick}
          className="w-full md:w-auto whitespace-nowrap"
        >
          Contact sales
        </JhButton>
      </div>
    </>
  );
};

export default SalesContact;
